import { getUserIdFromStorage, storeUserId } from "./storage"

export const runsOnServerSide = typeof window === "undefined"

/**
 * This function is a copy/paste from the french subscription flow
 * @returns a random user id
 */
export function generateUserId() {
  let userId = "DAL_" + Math.random().toString(36).substring(2, 4)
  userId += "_" + Date.now().toString()
  return userId
}

export function getOrCreateUserId(): string {
  if (runsOnServerSide) {
    return generateUserId()
  }
  const stored = getUserIdFromStorage()
  if (stored) {
    return stored
  }
  const newId = generateUserId()
  storeUserId(newId)
  return newId
}

//https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid
export function generatePetId() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}

/**
 * Source: https://grafikart.fr/tutoriels/drapeau-emoji-fonction-2152
 * @param code fr, gb, de...
 * @returns the emoji flag (🇫🇷, 🇬🇧, 🇩🇪)
 */
export function isoToEmoji(code: string) {
  return code
    .split("")
    .map((letter) => (letter.charCodeAt(0) % 32) + 0x1f1e5)
    .map((emojiCode) => String.fromCodePoint(emojiCode))
    .join("")
}

// Source: https://www.freecodecamp.org/news/javascript-debounce-example/
export function debounce(func: (...args: any[]) => any, timeout = 100) {
  let timer: NodeJS.Timeout
  return (...args: any[]) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func(args)
    }, timeout)
  }
}

